
import { UiActions } from '../actions';

import { createReducer, on } from '@ngrx/store';
import { StepsClientTypes, StepsNotClientTypes } from '../../shared/enums';

export interface StepNotClientState {
  StepNotClient: StepsClientTypes | StepsNotClientTypes;
}
export const InitialState: StepNotClientState = {
  StepNotClient: StepsNotClientTypes.STEP_PUBLIC_LANDING
};

const _stepsNotClientReducer = createReducer(
  InitialState,
  on(UiActions.Navigate, (state: StepNotClientState, { step }) => ({
    ...state,
    StepNotClient: step
  }))
);

export function stepsNotClientReducer(state, action) {
  if (action.type === StepsNotClientTypes.STEP_PUBLIC_LANDING) {
    state = StepsNotClientTypes.STEP_PUBLIC_LANDING;
  }
  return _stepsNotClientReducer(state, action);
}
